import React from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { TablerCaretUpDownFilled } from "../../assets/icons/LayoutIcon";
import useSortableData from "../../utils/SortData";
import EmptyTable from "../Layout/EmptyTable";

const SalesTable = ({ data = [], loading, headers = [], handleViewAction }) => {
  const { sortedItems, handleSort } = useSortableData(data);

  const renderTableCell = (item, header) => {
    switch (header) {
      case "revenue":
        return `₹${item.revenue.toLocaleString()}`;
      case "totalSales":
        return item.totalSales.toLocaleString();
      default:
        return item[header] || "N/A";
    }
  };

  return (
    <div>
      <div className="rounded-lg sm:border border-gray-300 overflow-x-auto my-4">
        <Table className="w-full border-gray-300 rounded-md">
          <Thead className="bg-gray-100 ">
            <Tr>
              {headers.map((header, index) => (
                <Th
                  key={index}
                  className="px-3 py-3 text-left font-semibold text-xs text-text1 cursor-pointer"
                  onClick={() =>
                    header.value !== "action" && handleSort(header.value)
                  }
                >
                  {header.value !== "action" ? (
                    <div className="flex items-center">
                      <TablerCaretUpDownFilled className="transition-transform sm:block hidden" />
                      <span className="text-text1 text-xs font-semibold ml-0 sm:ml-1">
                        {header.label}
                      </span>
                    </div>
                  ) : (
                    <span className="text-text1 text-xs font-semibold">
                      {header.label}
                    </span>
                  )}
                </Th>
              ))}
            </Tr>
          </Thead>

          <Tbody>
            {sortedItems.length > 0 ? (
              sortedItems.map((item, index) => (
                <Tr
                  key={index}
                  className="border-t hover:bg-gray-50 transition-colors"
                >
                  {headers.map(({ value }) =>
                    value !== "action" ? (
                      <Td
                        key={value}
                        className="px-3 py-4 text-xs font-normal text-text2"
                      >
                        {renderTableCell(item, value)}
                      </Td>
                    ) : (
                      <Td key="action" className="px-2 py-4 text-left w-8 ">
                        <button
                          className="text-xs font-medium text-[#1E40AF] bg-[#DBEAFE] px-2.5 py-0.5 rounded-md mr-3"
                          onClick={() => handleViewAction(item)}
                        >
                          View
                        </button>
                      </Td>
                    )
                  )}
                </Tr>
              ))
            ) : (
              <Tr>
                <Td
                  colSpan={headers.length}
                  className="text-center text-gray-500"
                >
                  <EmptyTable isApiLoading={loading} />
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </div>
    </div>
  );
};

export default SalesTable;
